import { AppleStore, GooglePlay } from "../../assets/svg";

const AppStoreBtns = () => {
  return (
    <div className="flex gap-3  text-white z-20">
      <a
        href="https://onelink.to/7hvxw3"
        target="_blank"
        rel="noopener noreferrer"
        className="sm:w-[200px]"
      >
        <button className="flex items-center bg-black rounded-md gap-3 px-3 py-1 w-full">
          <GooglePlay />
          <span className="flex flex-col text-left">
            <span className=" sm:text-base text-[10px] leading-3">
              Get it on
            </span>
            <span className="leading-5 sm:text-2xl text-xs">Google Play</span>
          </span>
        </button>
      </a>
      <a
        href="https://onelink.to/7hvxw3"
        target="_blank"
        rel="noopener noreferrer"
        className="sm:w-[200px]"
      >
        <button className="flex items-center bg-black rounded-md gap-3 px-3 py-1 w-full">
          <AppleStore />
          <span className="flex flex-col text-left">
            <span className="sm:text-base text-[10px] leading-3">
              Download on
            </span>
            <span className="leading-5 sm:text-2xl text-xs">App Store</span>
          </span>
        </button>
      </a>
    </div>
  );
};

export default AppStoreBtns;
